// extracted by mini-css-extract-plugin
export default {"wrapper":"Step_wrapper__5OX0+","container":"Step_container__UpGoj","footer":"Step_footer__7J4eY","header":"Step_header__zRjie","section":"Step_section__5gWFW"};